module.exports = __webpack_public_path__ + "img/edtih-steinkellner.80237cd4.jpg";